module.exports = __webpack_public_path__ + "img/banner12.201bfe02.jpg";